
    export default {
      mounted() {
        this.el.showModal()

        this.onClose = () => this.pushEvent("close_auth")
        this.el.addEventListener("close", this.onClose)

        // Ein Klick auf den Backdrop trifft das <dialog> selbst — der Inhalt liegt
        // im Kind darunter. Das native Element schliesst darauf nicht von allein.
        this.onClick = (e) => { if (e.target === this.el) this.el.close() }
        this.el.addEventListener("click", this.onClick)
      },

      destroyed() {
        this.el.removeEventListener("close", this.onClose)
        this.el.removeEventListener("click", this.onClick)
      }
    }
  